<template>
  <div>
    <v-btn icon dense color="#666" class="dialog-button" @click="dialog.info = true">
      <v-icon class="dialog-icon">mdi-information-outline</v-icon>
    </v-btn>
    <slot
      :value="dialog.info"
      :updateValue="
        (value) => {
          dialog.info = value
        }
      "
    >
      <component v-if="!!infoDialog" :is="infoDialog" :info="info" v-model="dialog.info" />
    </slot>
  </div>
</template>

<script>
import { Component } from 'vue'
import { Computed } from '@/_typedefs'
import AsthmaInfoDialogActivatorVue from '../../Asthma/FormNodes/InfoDialogs/AsthmaInfoDialogActivator.vue'
import AtopicDermatitisInfoDialogActivator from '@/components/NewAttendanceForm/AtopicDermatitis/FormNodes/Dialogs/AtopicDermatitisInfoDialogActivator.vue'

export default {
  name: 'InfoDialogActivatorComponent',
  props: {
    info: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      dialog: {
        info: false,
      },
      custom: this.info?.includes(':'),
    }
  },
  computed: {
    /** @type {Computed<Component | null>} */
    infoDialog() {
      if (!this.info) {
        return null
      }

      const [_, disease] = this.info.split(':').reverse()

      if (disease) {
        const diseaseMap = {
          asthma: AsthmaInfoDialogActivatorVue,
          'atopic-dermatitis': AtopicDermatitisInfoDialogActivator,
        }
        return diseaseMap[disease] ?? null
      }

      const dialogMap = {}

      return dialogMap[this.info] ?? null
    },
  },
}
</script>

<style scoped>
.dialog-button {
  height: 24px !important;
  width: 24px !important;
}
</style>
